// Iter 107c — Reusable hook: returns true when the Helpdesk app has
// been fully promoted to production (status=active AND no in-dev
// badges: roadmap / beta / new).  Cross-app surfaces (Partners,
// Customers, User rows, dashboards) call this before rendering the
// "Helpdesk tickets" link so nothing leaks while the module is still
// tagged as a proof-of-concept.
import { useEffect, useState } from "react";
import api from "@/lib/api";

let _cached = null;      // resolved app row (or null once we know it isn't live)
let _pending = null;     // in-flight promise so parallel callers dedupe

export function useHelpdeskLive() {
  const [live, setLive] = useState(() => _resolveLive(_cached));

  useEffect(() => {
    if (_cached !== null) { setLive(_resolveLive(_cached)); return; }
    if (!_pending) {
      _pending = api.get("/apps?limit=200")
        .then((r) => {
          const list = Array.isArray(r.data) ? r.data : (r.data?.apps || []);
          _cached = list.find((a) => a.route === "/helpdesk" || a.url === "/helpdesk") || false;
          return _cached;
        })
        .catch(() => { _cached = false; return false; })
        .finally(() => { _pending = null; });
    }
    _pending.then((app) => setLive(_resolveLive(app)));
  }, []);

  return live;
}

function _resolveLive(app) {
  if (!app) return false;
  if (app.status && app.status !== "active") return false;
  if (app.show_beta_badge)    return false;
  if (app.show_new_badge)     return false;
  if (app.show_roadmap_badge) return false;
  return true;
}
